// Pasta de versão do player na Bunny (a mesma do hostvsl-player.js).
export function flowPlayerScriptUrl(): string {
  const base = import.meta.env.VITE_API_PLAYJS_BUNNY || '';
  const version = import.meta.env.VITE_API_PLAYJS_VERSION || '';
  return `${base}${version}/hostvsl-flow.js`;
}

// Player usado só na pré-visualização do editor. VITE_FLOW_PLAYER_URL permite
// testar um hostvsl-flow.js local (ex.: http://localhost:5500/hostvsl-flow.js)
// sem mexer nas variáveis do player comum nem no código de incorporação.
export function flowPreviewScriptUrl(): string {
  return import.meta.env.VITE_FLOW_PLAYER_URL || flowPlayerScriptUrl();
}

// Código que o cliente cola na página (spec §4.1). Não muda ao publicar de novo.
export function generateFlowEmbedCode(publicId: string): string {
  return [
    `<hostvsl-flow\n  data-flow="${publicId}">\n</hostvsl-flow>`,
    `<script async\n  src="${flowPlayerScriptUrl()}"></script>`,
  ].join('\n');
}
